import { render, staticRenderFns } from "./phone-whatsapp-block.vue?vue&type=template&id=0e287282"
import script from "./phone-whatsapp-block.vue?vue&type=script&lang=js"
export * from "./phone-whatsapp-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports